window.egoCartMilestoneBarSelector = '.ego-cart-upsell-mount';
window.egoProductPageSelector = '.ab-classic-bundle-container#classicBundleContainer';
window.egoCountGiftProductsInRewardBarProgress = true;

(() => {
    const EGO_FREE_GIFT_PROP_KEY = "_EgoFreeGift";
    let cartPromise = null;

    async function getCart() {
    if (!cartPromise) {
        cartPromise = fetch("/cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        })
        .then((res) => res.json())
        .finally(() => {
            cartPromise = null;
        });
    }
    return cartPromise;
    }

    function blockButton(btn) {
    if (!btn) return;

    btn.setAttribute("disabled", "disabled");
    btn.setAttribute("aria-disabled", "true");
    btn.classList.add("disabled");
    btn.style.pointerEvents = "none";
    btn.style.opacity = "0.4";

    btn.addEventListener(
        "click",
        (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
        },
        true
    );
    }

    function lockQuantityUI(row) {
    if (!row) return;

    const quantityInput = row.querySelector(".quantity__input");
    const minusBtn = row.querySelector('.quantity__button[name="minus"]');
    const plusBtn = row.querySelector('.quantity__button[name="plus"]');
    const quantityWrapper = row.querySelector("quantity-input");

    row.dataset.egoGiftLocked = "true";

    if (quantityInput) {
        quantityInput.setAttribute("readonly", "readonly");
        quantityInput.setAttribute("disabled", "disabled");
        quantityInput.setAttribute("aria-disabled", "true");
        quantityInput.style.pointerEvents = "none";
        quantityInput.style.opacity = "0.6";
    }

    blockButton(minusBtn);
    blockButton(plusBtn);

    if (quantityWrapper) {
        quantityWrapper.classList.add("ego-gift-qty-locked");
    }
    }

    async function applyLock() {
    const cart = await getCart();

    const egoGiftKeys = new Set(
        (cart.items || [])
        .filter(
            (item) =>
            item.properties && item.properties[EGO_FREE_GIFT_PROP_KEY]
        )
        .map((item) => item.key)
    );

    document.querySelectorAll("tr.cart-item[data-key]").forEach((row) => {
        const key = row.getAttribute("data-key");
        if (key && egoGiftKeys.has(key)) {
        lockQuantityUI(row);
        }
    });
    }

    applyLock();

    const observer = new MutationObserver(() => {
    applyLock();
    });

    observer.observe(document.body, {
    childList: true,
    subtree: true,
    });

    async function refreshCartUI() {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (cart.items.length === 0) return;

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        cartItems?.updateQuantity(1, cart.items[0].quantity);
    }

    window.addEventListener('ego:api:gift_added', (e) => {
        refreshCartUI()
    });
    window.addEventListener('ego:api:gift_removed', (e) => {
        refreshCartUI();
    });
})();